import { RootState } from '../../store';

export const getLogsSelector = (state: RootState) => state?.ticketReducer.logs || [];
